import { useEffect, useState } from "react";
import { Hooks } from "../layout/utils/hooks";
import { useAppSelector } from "../redux/hooks";
import { GlobalHooks } from "../utils/Hooks";
import { useLocation } from 'react-router-dom'

const LivesIntegrated = ({language , token}) => {
  const search = useLocation().search
  const searchParams = new URLSearchParams(search)
  const LIVE_URL = useAppSelector((state) => state.LayoutReducer.LIVE_URL)
  const {cookies} = GlobalHooks()
  const OPTIONS = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Authorization" : "Bearer "+ cookies.authToken,
    },
  
  };
  const {getURLLive,getLiveUrl} = Hooks()
  useEffect(()=>{
    getURLLive(OPTIONS)
  },[])


    const newLivesIframe = "https:" + LIVE_URL
    const [urlLive, setUrlLive] = useState(null)
  useEffect(() => {
    window.addEventListener('message', function(event) {
      if(event?.data?.info === "goToDiffusionLive" && !event?.data?.live?.url_admin){
        getLiveUrl(event?.data?.live.id)
        .then(res=>setUrlLive(res))
      }
    })
    return()=>{
      window.removeEventListener('message', function(event) {
        setUrlLive(null)
      })
    }
  }, [])
    return (
      <iframe
        id="iframe_lives_display"
        src={(urlLive ?? (searchParams.get("id") ? newLivesIframe.replace("/list?",`/${searchParams.get("id")}/edit?`) : newLivesIframe))}
        allowFullScreen
        frameBorder={"0"}
        style={{ width: '100%', height: '100%', overflow: 'hidden' }}
      />
    );
  };
  
  export default LivesIntegrated